import React, { useEffect, useState } from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';

/** "Logged out in m:ss" notice while the student's other device is disconnected. Owns its 1 s tick. */
const secondsUntil = (deadline) => Math.max(0, Math.ceil((deadline - Date.now()) / 1000));

const DeviceLogoutCountdown = React.memo(({ deadline, deviceLabel }) => {
  const [left, setLeft] = useState(() => secondsUntil(deadline));

  useEffect(() => {
    setLeft(secondsUntil(deadline));
    const interval = setInterval(() => setLeft(secondsUntil(deadline)), 1000);
    return () => clearInterval(interval);
  }, [deadline]);

  const mm = Math.floor(left / 60);
  const ss = String(left % 60).padStart(2, '0');

  return (
    <div
      role="alert"
      style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', flexWrap: 'wrap',
        fontWeight: 'bold', color: '#9b2c2c', backgroundColor: '#fed7d7', border: '1px solid #fc8181',
        borderRadius: '8px', padding: '12px 16px', margin: '0 auto 14px', maxWidth: '600px',
      }}
    >
      <FaExclamationTriangle />
      <span>
        Reconnect your {deviceLabel} within{' '}
        <span style={{ fontSize: '20px', fontVariantNumeric: 'tabular-nums' }}>{mm}:{ss}</span>
        {' '}or you will be logged out of the exam automatically.
      </span>
    </div>
  );
});

export default DeviceLogoutCountdown;
